import Link from "next/link";
import ContactLink from "../ContactLink";

export const categoryFields = {
  "Late for Tour": [
    "your_name",
    "booking_id",
    "tour_name",
    "inquiry_details",
    "message",
  ],
  "Tour Availability": [
    "your_name",
    "tour_name",
    "requested_tour_date",
    "number_of_guests",
    "message",
  ],
  "Private Tour Inquiry": [
    "your_name",
    "tour_name",
    "requested_tour_date",
    "number_of_guests",
    "message",
  ],
  "Payment Issues": [
    "your_name",
    "tour_name",
    "requested_tour_date",
    "number_of_guests",
    "message",
  ],
  "Tour Content Details": [
    "your_name",
    "tour_name",
    "inquiry_details",
    "message",
  ],
  "Missing Tour Photos": ["your_name", "booking_id", "message"],
  "Missing Review Link": ["your_name", "booking_id", "message"],
  Other: ["your_name", "booking_id", "message"],
  "Tour Cancellation or Refund Request": ["your_name", "booking_id", "message"],
  "Tour Rescheduling": ["your_name", "booking_id", "message"],
  "Missing Booking Confirmation Email": [],
  "Tour Guide Application": [],
  "Business & Partnership Inquiry": [
    "your_name",
    "type_of_partnership",
    "is_connected_to_bokun",
    "type_of_promotion",
    "company_url",
    "country_of_residence",
    "message",
  ],
  "Media Inquiries (取材)": [
    "your_name",
    "company_url",
    "country_of_residence",
    "message",
  ],
};

export const inquiryDetailsOptions: Record<string, string[]> = {
  "Late for Tour": [
    "I am running late.",
    "I cannot find the guide or meeting point.",
    "Other",
  ],
  "Tour Content Details": [
    "Food Restrictions / Food Provided during the tour",
    "Kids Availability",
    "Tour End Point",
    "Other",
  ],
};

export const isConnectedToBokunOptions = [
  "yes",
  "no",
  "not yet but will be connected soon",
];

export const typeOfPartnership = [
  "Travel Blog / Website",
  "YouTube or Instagram Channel",
  "Travel Agency",
  "OTA",
  "Other",
];

export const typeOfPromotion = [
  "Affiliate Partnership (Commission-based)",
  "Sponsored Offer (Pay Per Activity)",
  "Sales Partnership",
  "Complimentary Tours (Exchange for SNS Posts)",
  "Other",
];

const getCancellationOrRescheduleText = (action: "cancel" | "reschedule") => {
  const actionLink = action === "cancel" ? "cancellation" : "rescheduling";
  return (
    <>
      If you would like to {action} your booking, please proceed to {actionLink}{" "}
      by clicking the {actionLink} link in your{" "}
      <strong>Booking Confirmation Email</strong>.
      <br />
      <br />
      If you cannot find your booking confirmation email, you can receive it
      again from{" "}
      <ContactLink href="/help/confirmation-email-recovery">here</ContactLink>
      .
      <br />
      <br />
      If you would like to {action} the booking after the limit due to some
      special reasons listed in the policy, please complete and submit the form
      below. You can check the MagicalTrip cancellation and rescheduling policy
      from <ContactLink href="/cancellation-policy">here</ContactLink>.
    </>
  );
};

export const categoryText = {
  "Tour Cancellation or Refund Request":
    getCancellationOrRescheduleText("cancel"),
  "Tour Rescheduling": getCancellationOrRescheduleText("reschedule"),
  "Missing Booking Confirmation Email": (
    <>
      If you cannot find your booking confirmation email, you can receive it
      again from{" "}
      <ContactLink href="/help/confirmation-email-recovery">here</ContactLink>
      .
      <br />
      <br />
      Your booking confirmation email includes your <strong>booking ID</strong>,
      the <strong>reservation date and time</strong>, and the tour{" "}
      <strong>meeting point information</strong>
    </>
  ),
  "Tour Guide Application": (
    <>
      Thank you for your interest in becoming a MagicalTrip guide! You can find
      more information about joining the team at our{" "}
      <ContactLink href="/recruit">guide recruitment page</ContactLink>.
    </>
  ),
  "Business & Partnership Inquiry": (
    <>
      <strong>Regarding Our Affiliate Program</strong>
      <br />
      Thank you so much for your inquiry on the MagicalTrip website.
      <br />
      <br />
      <strong>
        If you are still interested in our affiliate program, you can join on
        ShareASale, a 3rd-party affiliate system platform.
      </strong>
      <br />
      After you login to ShareAsale, you can find our affiliate program as
      below.
      <br />
      <br />
      ------------------------------------------------------------------
      <br />
      ShareAsale{" "}
      <Link
        href="https://www.shareasale.com/info/"
        target="_blank"
        rel="noopener noreferrer"
        className="ui-ContactUsLink"
      >
        https://www.shareasale.com/info/
      </Link>
      <br />
      Merchant Name: MagicalTrip Inc.
      <br />
      Merchant ID: #80059
      <br />
      Comission rate : 8%
      <br />
      Lockback window: 30days
      <br />
      ------------------------------------------------------------------
      <br />
      <br />
      You can read more about our affiliate and partnership program{" "}
      <ContactLink href="/business-partners">here</ContactLink>.
      <br />
      <br />
      If you are a travel agency seeking a sales partnership, please let us know
      and we will get back to you and explain our sales partnership in detail.
      <br />
      <br />
      We are looking forward to working with you!
      <br />
      <br />
      Thanks,
      <br />
      MagicalTrip
      <br />
      <br />
    </>
  ),
};
